import styled from "styled-components";
import { generic } from "../../../../../ui/_themes/constants";
import { Icon } from "../../../../../ui/IconSVG";
import { SettingTextField } from "../../../../../ui/SettingTextField";
import { SettingToggle } from "../../../../../ui/SettingToggle";

export const GameSettingsWrapper = styled.div`
  width: 35%;
  margin: 0 auto;
`;

export const GameSettingsRow = styled.div`
  display: flex;
  align-items: center;
  padding: 0.85em 0;
`;

export const GameSettingsIconWrapper = styled.div`
  flex: 0 0 4.2em;
  padding-right: 2em;
  height: 2.2em; /* IE only: remove when support for IE11 drops */
`;
export const GameSettingsIcon = styled(Icon)`
  color: ${generic.gameSettings.icon.color};
`;

export const GameSettingsLabel = styled<{ checked: boolean }, "span">("span")`
  flex: 1 1 60%;
  letter-spacing: 0.06em;
  font-weight: 700;
  font-size: 0.7em;
  user-select: none;
  color: ${({ checked }: any) =>
    checked
      ? generic.gameSettings.text.active
      : generic.gameSettings.text.color};
`;

export const SettingItemWrapper = styled.div`
  flex: 0 0 2em;
`;

export const StyledSettingToggle = styled(SettingToggle)`
  width: 1.6em;
  display: inline-block;
`;

export const StyledSettingTextField = styled(SettingTextField)`
  width: 100%;
  vertical-align: middle;
  display: inline-block;
`;
